import React from 'react';
import { HttpError } from '~/lib/useRequest';
import { useErrorHandler } from '~/hooks/useErrorHandler';
import { Dialog, Button, Flex, Text, useToasts, Heading } from '@applyboard/crystal-ui';
import { useConfirmEnrolmentActivity } from './useConfirmEnrolmentActivity';

export function ConfirmEnrolmentDialog({
  studentFirstName,
  studentLastName,
}: {
  studentFirstName: string;
  studentLastName: string;
}) {
  const toasts = useToasts();
  const activity = useConfirmEnrolmentActivity();
  const { apiError } = useErrorHandler();
  const applicantName = `${studentFirstName} ${studentLastName}`.trim();

  const onSubmit = () => {
    activity
      .confirmEnrolment()
      .then(() => {
        toasts.positive('Successfully Enrolled student.');
        activity.completeProcess();
      })
      .catch((err) => {
        apiError(
          HttpError.of(err).message === 'invalid status'
            ? 'Student is already enrolled, please refresh the page'
            : undefined
        );
      });
  };

  return (
    <Dialog
      size="md"
      open={true}
      onOpenChange={(isOpen) => {
        if (!isOpen) activity.completeProcess();
      }}
    >
      <Dialog.Heading>
        <Flex direction="row" gap={2}>
          <Flex direction="column">
            <Heading level={1} variant="titleM" intent="secondary">
              Confirm Enrolment
            </Heading>
          </Flex>
        </Flex>
      </Dialog.Heading>

      <Dialog.Content>
        <Flex direction="column" gap={8}>
          <Text variant="bodyM" intent="secondary">
            Confirm enrolment for {applicantName} This will update the application status.
          </Text>
        </Flex>
      </Dialog.Content>
      <Dialog.Actions>
        <Dialog.CloseButton disabled={activity.isBusy} width="fill">
          Cancel
        </Dialog.CloseButton>
        <Button intent="positive" loading={activity.isBusy} onClick={onSubmit} width="fill">
          Confirm Enrolment
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
}
